import React from 'react';
import './RateItem.less';

import RateIcon from 'new-images/rate.svg';

export const RateItem = ({isActive, isPlanned, onClick, onMouseEnter, onMouseLeave}) => {
	return <a className={`rate-item ${
		isActive ? 'rate-item--active' : ''
	} ${
		isPlanned ? 'rate-item--planned' : ''
	}`}
						onClick={onClick}
						onMouseEnter={onMouseEnter}
						onMouseLeave={onMouseLeave}
						dangerouslySetInnerHTML={{__html: RateIcon}}></a>
}
